import axios from 'axios'
import ApiService from './ApiService'
import { API_BASE_URL } from 'redux/constants/index'

export async function apiSignIn (data) {
    const payload = {
        emailAddress: data?.userName || data?.emailAddress || '',
        password: data?.password || ''
    }

    return axios.post(`${API_BASE_URL}Account/Login`, payload, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export async function apiSignUp (data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut (data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

export async function apiForgotPassword (data) {
    const emailAddress = String(data?.email || data?.emailAddress || '').trim()
    if (!emailAddress) {
        return Promise.reject(new Error('Email is required'))
    }

    // Match Account/Login: email goes in JSON body as emailAddress, not query string.
    return axios.post(`${API_BASE_URL}Account/ForgetPassword`, { emailAddress }, {
        headers: {
            accept: 'text/plain',
            'Content-Type': 'application/json',
        },
    })
}

export async function apiSetNewPassword({ id, token, password }) {
    const userId = String(id || '').trim()
    const resetToken = String(token || '').trim()
    const newPassword = String(password || '')

    if (!userId || !resetToken || !newPassword) {
        return Promise.reject(new Error('Reset link is invalid. Please request a new password reset email.'))
    }

    return axios.post(`${API_BASE_URL}Account/SetNewPassword`, {
        id: userId,
        token: resetToken,
        password: newPassword,
        emailAddress: '',
    }, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export async function apiResetPassword (data) {
    return apiSetNewPassword(data)
}
